import {event} from '../modules/event';
import {scriptonload} from '../modules/scriptonload';

class Accordion {
    constructor(wrapper) {
        this._declare(wrapper);
        this._addEvents();
    }

    _declare(wrapper){
        this.wrapper = wrapper;
        this.btnAll = wrapper.querySelectorAll('[data-Accordion-btn]');
    }

    _addEvents(){
        var self = this, l = this.btnAll.length, i = 0;

        for(i; i<l; i++){
            this.btnAll[i].onclick = function(){
                self._toggleItem.call(self, this);
                return false;
            }
        }
    }

    _toggleItem(btn) {
        var item = btn.parentElement,
            cls = item.className;

        if (cls.indexOf(' js-active') === -1)  item.className = cls + ' js-active';
        else item.className = cls.replace(' js-active', '');
    }
}

export {Accordion};










